import { Component, OnInit } from '@angular/core';
import { ServiceResult } from './service-result.model';
import { AvailableServicesService } from './available-services.service';
import { UIControlService } from 'src/app/shared/uicontrol.service';
import { combineLatest, BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ServiceProviderType } from '../service-provider-type.enum';
import { Service } from '../service.model';
import { IdentityService } from 'src/app/security/identity.service';

@Component({
  selector: 'app-available-services-layout',
  templateUrl: './available-services-layout.component.html',
  styleUrls: ['./available-services-layout.component.scss']
})
export class AvailableServicesLayoutComponent implements OnInit {
  public searchString$ = new BehaviorSubject<string>('');
  public providerTypes$ = new BehaviorSubject<Array<ServiceProviderType>>([]);

  public serviceResults: Array<ServiceResult>;
  constructor(
    private availableServices: AvailableServicesService,
    private ui: UIControlService,
    private identity: IdentityService
  ) {}

  public resultsLoading = true;

  public static filterServices(
    service: Service,
    searchString: string,
    providerTypes: Array<ServiceProviderType>,
    userKey: string
  ): boolean {
    if (service.userId === userKey) {
      return false;
    }

    if (
      providerTypes.length > 0 &&
      providerTypes.indexOf(service.type) === -1
    ) {
      return false;
    }

    if (searchString.length > 0) {
      const splitSearch = searchString.toLocaleLowerCase().split(' ');
      for (const searchWord of splitSearch) {
        if (
          service.description.toLocaleLowerCase().indexOf(searchWord) !== -1
        ) {
          continue;
        }
        if (service.title.toLocaleLowerCase().indexOf(searchWord) !== -1) {
          continue;
        }

        if (
          AvailableServicesLayoutComponent.searchStringArray(
            searchWord,
            service.tags
          )
        ) {
          continue;
        }

        if (
          AvailableServicesLayoutComponent.searchStringArray(
            searchWord,
            service.locations
          )
        ) {
          continue;
        }

        return false;
      }
    }

    return true;
  }

  public static searchStringArray(
    searchWord: string,
    searchArray: Array<string>
  ): boolean {
    if (!searchArray || searchArray?.length === 0) {
      return false;
    }

    for (const text of searchArray) {
      const splitTag = text.toLocaleLowerCase().split(' ');
      for (const tagSplit of splitTag) {
        if (tagSplit.indexOf(searchWord) !== -1) {
          return true;
        }
      }
    }
    return false;
  }

  public ngOnInit(): void {
    combineLatest([
      this.searchString$,
      this.providerTypes$,
      this.availableServices.getServices(),
      this.identity.userKey$
    ])
      .pipe(
        tap(() => {
          this.serviceResults = [];
          this.resultsLoading = true;
        }),
        map(([searchString, providerTypes, services, userKey]) => {
          return services.filter(serviceResult =>
            AvailableServicesLayoutComponent.filterServices(
              serviceResult.service,
              searchString,
              providerTypes,
              userKey
            )
          );
        }),
        tap(() => (this.resultsLoading = false))
      )
      .subscribe(results => (this.serviceResults = results));

      this.checkServiceList();
  }

  private checkServiceList()
  {
    console.log(this.availableServices);
    console.log(this.serviceResults);
  }
}
